// Content translations for Maharya B2B Landing Page
// Audience: Retailers, Department Stores, Private Label Brands, Wholesale Distributors

export const translations = {
  en: {
    // SEO Meta
    meta: {
      title: "Bulk Leather Accessories Manufacturer & Exporter | Maharya®",
     description: "Bulk leather accessories manufacturer & exporter for retailers, department stores & private label brands. MOQ 500–30,000+ units. WRAP & ISO certified.",
      keywords: "bulk leather accessories manufacturer, wholesale leather goods supplier, OEM leather manufacturer, private label leather, leather accessories exporter, B2B leather manufacturer, department store leather supplier, retail leather accessories wholesaler, container load leather, vegetable tanned leather manufacturer"
    },

    // Navigation
    nav: {
      manufacturing: "Manufacturing",
      capabilities: "Capabilities",
      whyUs: "Why Us",
      contact: "Contact"
    },

    // Hero Section
    hero: {
      eyebrow: "Leather craftsmanship",
      title: "Bulk Leather Accessories Manufacturer & Exporter",
      subtitle: "For Retailers, Department Stores, Private Label Brands & Wholesalers",
      description: "27 years serving global retail chains and brands. Orders from 500 to 30,000+ units. WRAP, C-TPAT, SEDEX & ISO certified production. Container-load exports to 25+ countries.",
      cta1: "Request Bulk Quote",
      cta2: "View Capabilities",
      ctaSubtext: "Free quote in 24 hours · No commitment · Direct from factory"
    },

    // Stats
    stats: {
      experience: "Years Experience",
      units: "Units/Month Capacity",
      clients: "Brand Partners",
      countries: "Countries Exported To"
    },

    // Manufacturing Section
    manufacturing: {
      title: "OEM & Private Label Leather Accessories Manufacturing",
      subtitle: "OEM Production • Private Label • Wholesale Distribution • Corporate Gifting • Container-Load Exports",
      tagline: "Certified B2B Leather Manufacturer & Exporter since 1999",
      
      features: [
        {
          title: "OEM & Private Label Expertise",
          description: "Full-service manufacturing for retail chains, department stores, and fashion brands. We produce to your designs, specifications, packaging and branding — ready for your shelves.",
          imageAlt: "OEM leather accessories manufacturing for private label brands"
        },
        {
          title: "Scalable Bulk Production",
          description: "30,000+ units per month capacity with German and Italian machinery. Consistent quality across small pilot runs to large-volume repeat orders — trusted for multi-container wholesale supply.",
          imageAlt: "Skilled production team delivering bulk leather manufacturing"
        },
        {
          title: "Export-Ready Compliance",
          description: "Six-stage QC process with full documentation for EU REACH, US CPSIA, UK and Canadian import standards. Ethical labor and environmental compliance audited by SEDEX, WRAP and C-TPAT.",
          imageAlt: "Quality control and export compliance for bulk leather orders"
        }
      ]
    },

    // Capabilities Section
    capabilities: {
      title: "Wholesale Manufacturing Capabilities",
      subtitle: "Bulk leather accessories crafted for global retail, department stores, and private label brands",
      
      categories: [
        { name: "Business Bags & Briefcases", imageAlt: "Wholesale leather business bags for retail brands" },
        { name: "Wallets & Cardholders", imageAlt: "Bulk leather wallets and small goods for private label" },
        { name: "Belts & Corporate Gifting", imageAlt: "Leather belts and corporate gifting for wholesale distribution" }
      ],
      
      services: [
        "Private Label Manufacturing",
        "OEM/ODM Production",
        "Wholesale Distribution Supply",
        "Department Store Programs",
        "Corporate Gifting (Bulk)",
        "Custom Design & Development"
      ]
    },

    // Why Choose Us
    whyUs: {
      title: "Why Global Retailers & Brands Choose Maharya",
      subtitle: "A trusted manufacturing partner for retail chains, department stores, private label brands, and wholesale distributors",
      
      reasons: [
        {
          title: "Full Compliance Certified",
          description: "WRAP, C-TPAT, SEDEX SMETA 4-Pillar & ISO 9001/45001 certified. Audit-ready documentation for EU REACH, US CPSIA and international retail compliance."
        },
        {
          title: "Proven Global Exporter",
          description: "U.S. registered corporation exporting to retail chains, department stores and distributors across North America, Europe, Australia, Asia and the Middle East."
        },
        {
          title: "Container-Load Capacity",
          description: "30,000+ units per month capacity with German and Italian machinery. Scale from 500-unit pilots to multi-container repeat orders without quality compromise."
        },
        {
          title: "Sustainable & Ethical",
          description: "Vegetable-tanned leather, fair-trade labor, responsible sourcing. Meets the ESG requirements of modern retailers, department stores and private label brands."
        },
        {
          title: "OEM/ODM Expertise",
          description: "27 years of building to buyer specifications: designs, materials, finishes, packaging, labeling and retail-ready fulfillment. Your brand, our craftsmanship."
        },
        {
          title: "On-Time Delivery Track Record",
          description: "Six-stage quality control and dedicated merchandising teams for retail chains. Consistent lead times, strict PO compliance, and full export documentation."
        }
      ]
    },

    // Contact Section
    contact: {
      title: "Partner With Us for Bulk Orders",
      description: "We work with retail chains, department stores, private label brands, and wholesale distributors. Minimum order 500 units. Typical orders 2,000–30,000 units. Share your project details below — our B2B team will respond within 24 hours.",
      officeLabel: "U.S. Office",
      phoneLabel: "Phone",
      emailLabel: "Email",
      
      form: {
        title: "Request Bulk Quote",
        bookCall: "📞 Book a free 30-min call",
        orFillForm: "— or fill the form —",
        reassurance: "Our B2B team responds within 24 business hours · no commitment required",
        stickyCta: "Get Bulk Quote",
        trustedBy: "TRUSTED BY 100+ GLOBAL BRANDS",
        fullName: "Full Name *",
        fullNamePlaceholder: "Buyer / Sourcing Manager Name",
        email: "Business Email *",
        emailPlaceholder: "buyer@yourcompany.com",
        company: "Company / Brand",
        companyPlaceholder: "Your Company or Brand Name",
        website: "Company Website",
        websitePlaceholder: "yourcompany.com",
        phone: "Phone",
        phonePlaceholder: "+1 (555) 000-0000",
        serviceInterest: "Business Type",
        serviceSelect: "Select your business type",
        message: "Project Details *",
        messagePlaceholder: "Share: product type, estimated order quantity, target price range, delivery market, and timeline.",
        submit: "Request Bulk Quote",
        submitting: "Sending...",
        
        services: [
          "Retail Chain / Brand",
          "Department Store",
          "Private Label Brand",
          "Wholesale Distributor",
          "OEM / ODM Project",
          "Corporate Gifting (500+ units)",
          "Other B2B"
        ],
        
        successMessage: "Thank you. Our B2B team will contact you within 24 hours.",
        errorMessage: "Failed to send message. Please email us directly at contact@maharya.com"
      }
    },

    // Footer
    footer: {
      description: "Bulk leather accessories manufacturer and exporter serving global retailers, department stores, and private label brands since 1999.",
      
      services: {
        title: "Services",
        links: [
          "Private Label Manufacturing",
          "OEM / ODM Production",
          "Wholesale Distribution",
          "Corporate Gifting (Bulk)"
        ]
      },
      
      company: {
        title: "Company",
        links: [
          "About Us",
          "Certifications",
          "Sustainability",
          "Quality Standards"
        ]
      },
      
      contact: {
        title: "Contact"
      },
      
      copyright: "© 2026 Maharya® Inc. All rights reserved. | WRAP • C-TPAT • SEDEX • ISO Certified"
    }
  },

  es: {
    // SEO Meta - Spanish
    meta: {
      title: "Fabricante y exportador de accesorios de piel | Maharya",
      description: "Fabricante y exportador de accesorios de piel al por mayor para minoristas, grandes almacenes y marcas privadas. MOQ 500–30 000+. WRAP e ISO certificado.",
      keywords: "fabricante de accesorios de piel al por mayor, proveedor mayorista de piel, fabricante OEM de piel, marca privada de piel, exportador de accesorios de piel, fabricante B2B, proveedor para grandes almacenes, distribuidor mayorista de piel, producción en contenedor, fabricante de piel curtida vegetal"
    },

    // Navigation
    nav: {
      manufacturing: "Fabricación",
      capabilities: "Capacidades",
      whyUs: "Por qué elegir Maharya",
      contact: "Contacto"
    },

    // Hero Section
    hero: {
      eyebrow: "Artesanía en piel",
      title: "Fabricante y exportador de accesorios de piel",
      subtitle: "Para cadenas minoristas, grandes almacenes, marcas de marca privada y mayoristas",
      description: "27 años al servicio de cadenas minoristas y marcas globales. Pedidos de 500 a 30.000+ unidades. Producción certificada WRAP, C-TPAT, SEDEX e ISO. Exportaciones en contenedor a más de 25 países.",
      cta1: "Solicitar presupuesto al por mayor",
      cta2: "Ver capacidades",
      ctaSubtext: "Presupuesto en 24 horas · Sin compromiso · Directo de fábrica"
    },

    // Stats
    stats: {
      experience: "años de experiencia",
      units: "unidades/mes de capacidad",
      clients: "marcas asociadas",
      countries: "países de exportación"
    },

    // Manufacturing Section
    manufacturing: {
      title: "Fabricación OEM y marca privada de accesorios de piel",
      subtitle: "Producción OEM • Marca privada • Distribución mayorista • Regalos corporativos • Exportaciones en contenedor",
      tagline: "Fabricante y exportador B2B certificado de piel desde 1999",
      
      features: [
        {
          title: "Especialistas en OEM y marca privada",
          description: "Fabricación integral para cadenas minoristas, grandes almacenes y marcas de moda. Producimos según sus diseños, especificaciones, embalaje y marca, listos para sus puntos de venta.",
          imageAlt: "Fabricación OEM de accesorios de piel para marcas de marca privada"
        },
        {
          title: "Producción al por mayor escalable",
          description: "Capacidad de más de 30.000 unidades al mes con maquinaria alemana e italiana. Calidad constante desde tiradas piloto reducidas hasta grandes pedidos recurrentes, con suministro mayorista multicontenedor de confianza.",
          imageAlt: "Equipo de producción cualificado para fabricación al por mayor"
        },
        {
          title: "Cumplimiento listo para exportación",
          description: "Proceso de control de calidad en seis etapas con documentación completa para REACH de la UE, CPSIA de EE. UU. y estándares de importación de Reino Unido y Canadá. Auditoría ética y ambiental por SEDEX, WRAP y C-TPAT.",
          imageAlt: "Control de calidad y cumplimiento para exportación de pedidos al por mayor"
        }
      ]
    },

    // Capabilities Section
    capabilities: {
      title: "Capacidades de fabricación al por mayor",
      subtitle: "Accesorios de piel al por mayor para cadenas minoristas globales, grandes almacenes y marcas de marca privada",
      
      categories: [
        { name: "Bolsos ejecutivos y carteras", imageAlt: "Bolsos ejecutivos de piel al por mayor para marcas minoristas" },
        { name: "Carteras y tarjeteros", imageAlt: "Carteras de piel al por mayor para marca privada" },
        { name: "Cinturones y regalos corporativos", imageAlt: "Cinturones de piel y regalos corporativos para distribución mayorista" }
      ],
      
      services: [
        "Fabricación para marca privada",
        "Producción OEM/ODM",
        "Suministro a distribución mayorista",
        "Programas para grandes almacenes",
        "Regalos corporativos (al por mayor)",
        "Diseño y desarrollo a medida"
      ]
    },

    // Why Choose Us
    whyUs: {
      title: "Por qué las cadenas y marcas globales eligen Maharya",
      subtitle: "Un socio de fabricación de confianza para cadenas minoristas, grandes almacenes, marcas de marca privada y distribuidores mayoristas",
      
      reasons: [
        {
          title: "Totalmente certificado",
          description: "Certificado WRAP, C-TPAT, SEDEX SMETA 4-Pillar e ISO 9001/45001. Documentación lista para auditorías conforme a REACH (UE), CPSIA (EE. UU.) y cumplimiento minorista internacional."
        },
        {
          title: "Exportador global consolidado",
          description: "Sociedad registrada en EE. UU. que exporta a cadenas minoristas, grandes almacenes y distribuidores en América del Norte, Europa, Australia, Asia y Oriente Medio."
        },
        {
          title: "Capacidad para contenedor completo",
          description: "Capacidad de más de 30.000 unidades al mes con maquinaria alemana e italiana. Escalamos desde pilotos de 500 unidades hasta pedidos repetidos multicontenedor sin comprometer la calidad."
        },
        {
          title: "Sostenible y ético",
          description: "Piel curtida vegetal, mano de obra con comercio justo y abastecimiento responsable. Cumple con los requisitos ESG de los minoristas modernos, grandes almacenes y marcas de marca privada."
        },
        {
          title: "Experiencia en OEM/ODM",
          description: "27 años fabricando según las especificaciones del comprador: diseños, materiales, acabados, embalaje, etiquetado y preparación lista para el punto de venta. Su marca, nuestra artesanía."
        },
        {
          title: "Historial de entregas puntuales",
          description: "Control de calidad en seis etapas y equipos de merchandising dedicados a cadenas minoristas. Plazos de entrega consistentes, cumplimiento estricto de órdenes de compra y documentación completa de exportación."
        }
      ]
    },

    // Contact Section
    contact: {
      title: "Asóciese con nosotros para pedidos al por mayor",
      description: "Trabajamos con cadenas minoristas, grandes almacenes, marcas de marca privada y distribuidores mayoristas. Pedido mínimo: 500 unidades. Pedidos habituales: 2.000–30.000 unidades. Comparta los detalles de su proyecto abajo y nuestro equipo B2B responderá en un plazo de 24 horas.",
      officeLabel: "Oficina en EE. UU.",
      phoneLabel: "Teléfono",
      emailLabel: "Correo electrónico",
      
      form: {
        title: "Solicitar presupuesto al por mayor",
        bookCall: "📞 Reserve una llamada gratuita de 30 min",
        orFillForm: "— o rellene el formulario —",
        reassurance: "Nuestro equipo B2B responde en 24 horas hábiles · sin compromiso",
        stickyCta: "Solicitar presupuesto",
        trustedBy: "USADO POR MÁS DE 100 MARCAS GLOBALES",
        fullName: "Nombre completo *",
        fullNamePlaceholder: "Nombre del comprador / responsable de compras",
        email: "Correo electrónico corporativo *",
        emailPlaceholder: "comprador@suempresa.com",
        company: "Empresa / Marca",
        companyPlaceholder: "Nombre de su empresa o marca",
        website: "Sitio web de la empresa",
        websitePlaceholder: "suempresa.com",
        phone: "Teléfono",
        phonePlaceholder: "+34 (555) 000-0000",
        serviceInterest: "Tipo de negocio",
        serviceSelect: "Seleccione su tipo de negocio",
        message: "Detalles del proyecto *",
        messagePlaceholder: "Comparta: tipo de producto, cantidad estimada del pedido, rango de precio objetivo, mercado de entrega y plazo.",
        submit: "Solicitar presupuesto al por mayor",
        submitting: "Enviando...",
        
        services: [
          "Cadena minorista / Marca",
          "Grandes almacenes",
          "Marca de marca privada",
          "Distribuidor mayorista",
          "Proyecto OEM / ODM",
          "Regalos corporativos (500+ unidades)",
          "Otro B2B"
        ],
        
        successMessage: "Gracias. Nuestro equipo B2B se pondrá en contacto con usted en un plazo de 24 horas.",
        errorMessage: "No se pudo enviar el mensaje. Envíenos un correo electrónico directamente a contact@maharya.com"
      }
    },

    // Footer
    footer: {
      description: "Fabricante y exportador de accesorios de piel al por mayor al servicio de minoristas, grandes almacenes y marcas de marca privada globales desde 1999.",
      
      services: {
        title: "Servicios",
        links: [
          "Fabricación para marca privada",
          "Producción OEM / ODM",
          "Distribución mayorista",
          "Regalos corporativos (al por mayor)"
        ]
      },
      
      company: {
        title: "Empresa",
        links: [
          "Sobre nosotros",
          "Certificaciones",
          "Sostenibilidad",
          "Estándares de calidad"
        ]
      },
      
      contact: {
        title: "Contacto"
      },
      
      copyright: "© 2026 Maharya® Inc. Todos los derechos reservados. | WRAP • C-TPAT • SEDEX • ISO Certified"
    }
  },

  fr: {
    // SEO Meta - French
    meta: {
      title: "Fabricant et exportateur de maroquinerie en gros | Maharya",
      description: "Fabricant et exportateur de maroquinerie en gros pour détaillants, grands magasins et marques en marque privée. MOQ 500–30 000+. Certifié WRAP et ISO.",
      keywords: "fabricant de maroquinerie en gros, fournisseur grossiste de cuir, fabricant OEM de cuir, marque privée cuir, exportateur de maroquinerie, fabricant B2B cuir, fournisseur pour grands magasins, distributeur grossiste cuir, production par conteneur, fabricant cuir tanné végétal"
    },

    // Navigation
    nav: {
      manufacturing: "Fabrication",
      capabilities: "Capacités",
      whyUs: "Pourquoi nous choisir",
      contact: "Contact"
    },

    // Hero Section
    hero: {
      eyebrow: "Savoir-faire maroquinier",
      title: "Fabricant et exportateur de maroquinerie en gros",
      subtitle: "Pour les chaînes de détail, grands magasins, marques en marque privée et grossistes",
      description: "27 ans au service des chaînes de détail et des marques mondiales. Commandes de 500 à 30 000+ unités. Production certifiée WRAP, C-TPAT, SEDEX et ISO. Exportations par conteneur vers plus de 25 pays.",
      cta1: "Soumission en gros",
      cta2: "Voir nos capacités",
      ctaSubtext: "Devis sous 24 heures · Sans engagement · Direct usine"
    },

    // Stats
    stats: {
      experience: "Années d'expérience",
      units: "Unités/mois de capacité",
      clients: "Marques partenaires",
      countries: "Pays d'exportation"
    },

    // Manufacturing Section
    manufacturing: {
      title: "Fabrication OEM et marque privée de maroquinerie",
      subtitle: "Production OEM • Marque privée • Distribution en gros • Cadeaux corporatifs • Exportations par conteneur",
      tagline: "Fabricant et exportateur B2B certifié de maroquinerie depuis 1999",
      
      features: [
        {
          title: "Expertise OEM et marque privée",
          description: "Fabrication complète pour les chaînes de détail, les grands magasins et les marques de mode. Nous produisons selon vos designs, cahiers des charges, emballages et marques, prêts pour vos rayons.",
          imageAlt: "Fabrication OEM de maroquinerie pour marques en marque privée"
        },
        {
          title: "Production en gros évolutive",
          description: "Capacité de plus de 30 000 unités par mois avec des équipements allemands et italiens. Qualité constante, des séries pilotes aux grandes commandes récurrentes, avec approvisionnement multi-conteneur de confiance.",
          imageAlt: "Équipe de production qualifiée pour la fabrication en gros"
        },
        {
          title: "Conformité prête à l'exportation",
          description: "Processus de contrôle qualité en six étapes avec documentation complète pour REACH UE, CPSIA USA et normes d'importation britanniques et canadiennes. Audit éthique et environnemental par SEDEX, WRAP et C-TPAT.",
          imageAlt: "Contrôle qualité et conformité pour exportation de commandes en gros"
        }
      ]
    },

    // Capabilities Section
    capabilities: {
      title: "Capacités de fabrication en gros",
      subtitle: "Accessoires en cuir en gros pour les chaînes de détail internationales, grands magasins et marques en marque privée",
      
      categories: [
        { name: "Sacs professionnels et porte-documents", imageAlt: "Sacs professionnels en cuir en gros pour marques de détail" },
        { name: "Portefeuilles et porte-cartes", imageAlt: "Portefeuilles en cuir en gros pour marque privée" },
        { name: "Ceintures et cadeaux corporatifs", imageAlt: "Ceintures en cuir et cadeaux corporatifs pour distribution en gros" }
      ],
      
      services: [
        "Fabrication en marque privée",
        "Production OEM/ODM",
        "Fourniture à la distribution en gros",
        "Programmes pour grands magasins",
        "Cadeaux corporatifs (en gros)",
        "Conception et développement sur mesure"
      ]
    },

    // Why Choose Us
    whyUs: {
      title: "Pourquoi les chaînes et marques internationales choisissent Maharya",
      subtitle: "Un partenaire de fabrication de confiance pour les chaînes de détail, les grands magasins, les marques en marque privée et les distributeurs grossistes",
      
      reasons: [
        {
          title: "Pleinement certifié",
          description: "Certifié WRAP, C-TPAT, SEDEX SMETA 4-Pillar et ISO 9001/45001. Documentation prête pour audit conforme à REACH (UE), CPSIA (USA) et à la conformité internationale du commerce de détail."
        },
        {
          title: "Exportateur mondial reconnu",
          description: "Société immatriculée aux États-Unis, exportant vers des chaînes de détail, grands magasins et distributeurs en Amérique du Nord, en Europe, en Australie, en Asie et au Moyen-Orient."
        },
        {
          title: "Capacité conteneur complet",
          description: "Plus de 30 000 unités par mois avec équipements allemands et italiens. De la série pilote de 500 unités aux commandes récurrentes multi-conteneurs, sans compromis sur la qualité."
        },
        {
          title: "Durable et éthique",
          description: "Cuir tanné végétal, main-d'œuvre équitable, approvisionnement responsable. Répond aux exigences ESG des distributeurs modernes, grands magasins et marques en marque privée."
        },
        {
          title: "Expertise OEM/ODM",
          description: "27 ans de fabrication selon les spécifications des acheteurs : designs, matériaux, finitions, emballages, étiquetage et préparation prête pour le point de vente. Votre marque, notre savoir-faire."
        },
        {
          title: "Livraisons à temps éprouvées",
          description: "Contrôle qualité en six étapes et équipes merchandising dédiées aux chaînes de détail. Délais constants, conformité stricte aux bons de commande et documentation d'exportation complète."
        }
      ]
    },

    // Contact Section
    contact: {
      title: "Associez-vous à nous pour des commandes en gros",
      description: "Nous travaillons avec des chaînes de détail, des grands magasins, des marques en marque privée et des distributeurs grossistes. Commande minimum : 500 unités. Commandes habituelles : 2 000 à 30 000 unités. Partagez les détails de votre projet ci-dessous — notre équipe B2B vous répondra sous 24 heures.",
      officeLabel: "Bureau aux États-Unis",
      phoneLabel: "Téléphone",
      emailLabel: "Courriel",
      
      form: {
        title: "Soumission en gros",
        bookCall: "📞 Réserver un appel gratuit de 30 min",
        orFillForm: "— ou remplissez le formulaire —",
        reassurance: "Notre équipe B2B répond sous 24 heures ouvrables · sans engagement",
        stickyCta: "Demander un devis",
        trustedBy: "PLUS DE 100 MARQUES MONDIALES NOUS FONT CONFIANCE",
        fullName: "Nom complet *",
        fullNamePlaceholder: "Nom de l'acheteur / responsable des achats",
        email: "Courriel professionnel *",
        emailPlaceholder: "acheteur@votreentreprise.com",
        company: "Entreprise / Marque",
        companyPlaceholder: "Nom de votre entreprise ou marque",
        website: "Site web de l'entreprise",
        websitePlaceholder: "votreentreprise.com",
        phone: "Téléphone",
        phonePlaceholder: "+1 (555) 000-0000",
        serviceInterest: "Type d'activité",
        serviceSelect: "Sélectionnez votre type d'activité",
        message: "Détails du projet *",
        messagePlaceholder: "Indiquez : type de produit, quantité estimée, fourchette de prix cible, marché de livraison et délai.",
        submit: "Demander une soumission en gros",
        submitting: "Envoi en cours...",
        
        services: [
          "Chaîne de détail / Marque",
          "Grand magasin",
          "Marque en marque privée",
          "Distributeur grossiste",
          "Projet OEM / ODM",
          "Cadeaux corporatifs (500+ unités)",
          "Autre B2B"
        ],
        
        successMessage: "Merci. Notre équipe B2B vous contactera sous 24 heures.",
        errorMessage: "L'envoi du message a échoué. Veuillez nous écrire directement à contact@maharya.com"
      }
    },

    // Footer
    footer: {
      description: "Fabricant et exportateur de maroquinerie en gros au service des chaînes de détail, grands magasins et marques en marque privée depuis 1999.",
      
      services: {
        title: "Services",
        links: [
          "Fabrication en marque privée",
          "Production OEM / ODM",
          "Distribution en gros",
          "Cadeaux corporatifs (en gros)"
        ]
      },
      
      company: {
        title: "Entreprise",
        links: [
          "À notre sujet",
          "Certifications",
          "Durabilité",
          "Normes de qualité"
        ]
      },
      
      contact: {
        title: "Contact"
      },
      
      copyright: "© 2026 Maharya® Inc. Tous droits réservés. | WRAP • C-TPAT • SEDEX • ISO Certified"
    }
  }
};

export default translations;
